import React, { Component } from 'react';
import { UIView} from 'ui-router-react'; 
import { CSSTransitionGroup } from 'react-transition-group'; 

class RootContainer extends Component {
	render() {		   
		   return (
					<UIView render={(Comp, props) =>
					  <CSSTransitionGroup
						transitionName="example"
						transitionEnterTimeout={250}
						transitionLeaveTimeout={250}>
						<Comp {...props} key={props.transition} />
					  </CSSTransitionGroup>
					}/>
			)
	   
	}
}
export default RootContainer;


// WEBPACK FOOTER //
// ./src/containers/RootContainer.js